import React from 'react'
import { Modal, Button, Row, Col, Card } from 'react-bootstrap'
import * as FaIcons from 'react-icons/fa'
import PropTypes from 'prop-types'

const SelectModalidadModal = ({ show, onHide, onSelectIndividual, onSelectMasiva, onSelectGeosort }) => {
    return (
        <Modal
            show={show}
            onHide={onHide}
            size="lg"
            centered
            backdrop="static"
            keyboard={true}>
            <Modal.Header closeButton>
                <Modal.Title>
                    <FaIcons.FaRoute className="me-2" />
                    Seleccionar Modalidad de Carga
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div className="mb-3">
                    <p className="text-muted">
                        Seleccione el tipo de carga que desea realizar:
                    </p>
                </div>

                <Row className="g-4">
                    {/* Opción: Carga Individual */}
                    <Col md={4}>
                        <Card 
                            className="h-100 border-2 hover-shadow"
                            style={{ 
                                cursor: 'pointer',
                                transition: 'all 0.3s ease',
                                borderColor: '#0d6efd'
                            }}
                            onClick={onSelectIndividual}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.transform = 'translateY(-5px)';
                                e.currentTarget.style.boxShadow = '0 8px 16px rgba(13, 110, 253, 0.2)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = 'none';
                            }}>
                            <Card.Body className="text-center p-4">
                                <div 
                                    className="mb-3"
                                    style={{
                                        fontSize: '3rem',
                                        color: '#0d6efd'
                                    }}>
                                    <FaIcons.FaFileAlt />
                                </div>
                                <Card.Title className="mb-3">
                                    Carga Individual
                                </Card.Title>
                                <Card.Text className="text-muted">
                                    Crea una ruta de forma individual ingresando los datos manualmente.
                                </Card.Text>
                                <Button 
                                    variant="primary" 
                                    className="mt-3 w-100"
                                    onClick={onSelectIndividual}>
                                    <FaIcons.FaPlus className="me-2" />
                                    Crear Ruta Individual
                                </Button>
                            </Card.Body>
                        </Card>
                    </Col>

                    {/* Opción: Carga Masiva */}
                    <Col md={4}>
                        <Card
                            className="h-100 border-2 hover-shadow"
                            style={{
                                cursor: 'pointer',
                                transition: 'all 0.3s ease',
                                borderColor: '#198754'
                            }}
                            onClick={onSelectMasiva}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.transform = 'translateY(-5px)';
                                e.currentTarget.style.boxShadow = '0 8px 16px rgba(25, 135, 84, 0.2)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = 'none';
                            }}>
                            <Card.Body className="text-center p-4">
                                <div
                                    className="mb-3"
                                    style={{
                                        fontSize: '3rem',
                                        color: '#198754'
                                    }}>
                                    <FaIcons.FaFileExcel />
                                </div>
                                <Card.Title className="mb-3">
                                    Carga Masiva
                                </Card.Title>
                                <Card.Text className="text-muted">
                                    Carga múltiples rutas simultáneamente mediante un archivo Excel.
                                </Card.Text>
                                <Button
                                    variant="success"
                                    className="mt-3 w-100"
                                    onClick={onSelectMasiva}>
                                    <FaIcons.FaUpload className="me-2" />
                                    Cargar Rutas Masivas
                                </Button>
                            </Card.Body>
                        </Card>
                    </Col>

                    {/* Opción: Recargar fecha GeoSort */}
                    <Col md={4}>
                        <Card
                            className="h-100 border-2 hover-shadow"
                            style={{
                                cursor: 'pointer',
                                transition: 'all 0.3s ease',
                                borderColor: '#fd7e14'
                            }}
                            onClick={onSelectGeosort}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.transform = 'translateY(-5px)';
                                e.currentTarget.style.boxShadow = '0 8px 16px rgba(253, 126, 20, 0.2)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = 'translateY(0)';
                                e.currentTarget.style.boxShadow = 'none';
                            }}>
                            <Card.Body className="text-center p-4">
                                <div
                                    className="mb-3"
                                    style={{
                                        fontSize: '3rem',
                                        color: '#fd7e14'
                                    }}>
                                    <FaIcons.FaSyncAlt />
                                </div>
                                <Card.Title className="mb-3">
                                    Recargar GeoSort
                                </Card.Title>
                                <Card.Text className="text-muted">
                                    Reprocesa un día completo de rutas/guías de GeoSort (Falabella) que quedó mal cargado.
                                </Card.Text>
                                <Button
                                    variant="warning"
                                    className="mt-3 w-100"
                                    onClick={onSelectGeosort}>
                                    <FaIcons.FaSyncAlt className="me-2" />
                                    Recargar Fecha GeoSort
                                </Button>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Modal.Body>

            <Modal.Footer>
                <Button variant="secondary" onClick={onHide}>
                    Cancelar
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

SelectModalidadModal.propTypes = {
    show: PropTypes.bool.isRequired,
    onHide: PropTypes.func.isRequired,
    onSelectIndividual: PropTypes.func.isRequired,
    onSelectMasiva: PropTypes.func.isRequired,
    onSelectGeosort: PropTypes.func.isRequired
}

export default SelectModalidadModal
